/**
 * Build a same-origin deep-link to a location alarm's investigation view.
 * Returns `null` when either `alarmId` or `partitionKey` is missing.
 *
 * This is the canonical builder for URLs of the shape
 * `${origin}/location-alarms/${id}?partitionKey=${key}`.
 * The same pattern is currently inlined in several other files
 * (Header.tsx, ResolveIncidentModal.tsx, LocationAlarmDetailsRoot.tsx,
 * ResolveEscalationModal.tsx) — prefer importing this helper over
 * duplicating the template literal.
 */
export function locationAlarmUrl(
  alarmId?: string,
  partitionKey?: string
): string | null {
  if (!alarmId || !partitionKey) return null;
  return `${window.location.origin}/location-alarms/${alarmId}?partitionKey=${partitionKey}`;
}
